import { render, staticRenderFns } from "./bmi-icon.vue?vue&type=template&id=c06ee49c&scoped=true"
import script from "./bmi-icon.vue?vue&type=script&lang=js"
export * from "./bmi-icon.vue?vue&type=script&lang=js"
import style0 from "./bmi-icon.vue?vue&type=style&index=0&id=c06ee49c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06ee49c",
  null
  
)

export default component.exports